module.exports = __webpack_public_path__ + "static/media/dziennik.fcf528a1.svg";